import React, { useState } from 'react';
import classes from "./CustomTimePicker.module.scss";


const minutesList = ['00', '15', '30', '45'];
const periods = ['AM', 'PM'];

const getTimes = (dataForm)=> {
  const dateObj = new Date();

  // Extract hours, minutes, and seconds from the original time string
  const [hours, minutes, seconds] = dataForm.split(':');

  // Set the hours, minutes, and seconds in the Date object
  dateObj.setHours(parseInt(hours, 10));
  dateObj.setMinutes(parseInt(minutes, 10));
  dateObj.setSeconds(parseInt(seconds, 10));

  // Format the result as hh:mm AM/PM
  const formattedTime = dateObj.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
  
  const [timePart, meridian] = formattedTime.split(' ');
  const [hour, minute] = timePart.split(':');

  return {
    hour, minute, meridian
  }
}

const convertTimeStyle = (timeForm) => {
  // Create a new Date object
  const dateObj = new Date();
      
  // Extract hours and minutes from the original time string
  const [hours, , minutes, , meridian] = timeForm.split(' ');

  // Convert hours to 24-hour format if PM
  dateObj.setHours(meridian === 'PM' ? parseInt(hours, 10) + 12 : parseInt(hours, 10));
  dateObj.setMinutes(parseInt(minutes, 10));

  // Format the result as HH:mm AM/PM
  const formattedTime = dateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

  return formattedTime;
}


export const CustomTimePicker = (props) => {
  const {data, onChange } = props;
  const [showPicker, setShowPicker] = useState(false);
  const [selectedHour, setSelectedHour] = useState(data ? getTimes(data).hour : '12');
  const [selectedMinute, setSelectedMinute] = useState(data ? getTimes(data).minute : '00');
  const [selectedPeriod, setSelectedPeriod] = useState(data ? getTimes(data).meridian : 'AM');

  const handleTimeChange = () => {
    const originalTime = `${selectedHour} : ${selectedMinute}  ${selectedPeriod}`;

    // Format the result as HH:mm AM/PM
    const formattedTime = convertTimeStyle(originalTime);
    onChange(formattedTime)
  }

  const handleClockIconClick = () => {
    setShowPicker(!showPicker);
    if (!!showPicker) {
      handleTimeChange()
    }
  };

  const handleMinuteSelect = (minute) => {
    setSelectedMinute(minute);
  };

  const handlePeriodSelect = (period) => {
    setSelectedPeriod(period);
  };


  const dateInSelectedTimes = (value, selectedField) => {
    let isInSelectedDates = false;
    if (selectedField === 'hour') {
        if (datesAreOnSameTime(value, selectedHour)) {
            isInSelectedDates = true;
        }
    } else if (selectedField === 'min') {
        if (datesAreOnSameTime(value, selectedMinute)) {
            isInSelectedDates = true;
        }
    } else {
        if (datesAreOnSameTime(value, selectedPeriod)) {
            isInSelectedDates = true;
        }
    }
   
    return isInSelectedDates;
  };

  const datesAreOnSameTime = (first, second) => {
    if (!first || !second) return false;
    
    if (first === second)
        return true

  };

  const handleInputChange = (e, timeType) => {

    let inputValue = e.target.value;
    let originalTime = `${selectedHour} : ${selectedMinute}  ${selectedPeriod}`;
    console.log(inputValue, '====-=-=-=')

    // Remove non-numeric characters
    inputValue = inputValue.replace(/[^0-9]/g, '');

    if (timeType === 'hour') {
      // Ensure the value is within the range 00-59
      if (inputValue !== '' && (parseInt(inputValue) < 0 || parseInt(inputValue) > 12)) {
        // You can choose to handle out-of-range values here, e.g., show an error message
        console.log('Input out of range (00-12)');
        return;
      }
      setSelectedHour(inputValue);
      originalTime = `${inputValue} : ${selectedMinute}  ${selectedPeriod}`;
    } else {
      // Ensure the value is within the range 00-59
      if (inputValue !== '' && (parseInt(inputValue) < 0 || parseInt(inputValue) > 59)) {
        // You can choose to handle out-of-range values here, e.g., show an error message
        console.log('Input out of range (00-59)');
        return;
      }
      setSelectedMinute(inputValue);
      originalTime = `${selectedHour} : ${inputValue}  ${selectedPeriod}`;
    }

    // Format the result as HH:mm AM/PM
    const formattedTime = convertTimeStyle(originalTime);
    onChange(formattedTime)
  };

  return (
    <div className={classes.customTimePicker}>
      <div className={classes.customTimePickerContainer}>
            <div className={classes.customTimePickerContainer} onClick={handleClockIconClick}>
                <input
                  type="text"
                  id="hours"
                  name="hours"
                  value={`${selectedHour}`}
                  onChange={(e) => {handleInputChange(e, 'hour')}}
                  style={{width:'30px'}}
                />
                :
                <input 
                  type="text"
                  id="mins"
                  name="mins"
                  value={`${selectedMinute}`}
                  onChange={(e) => handleInputChange(e, 'mins')}
                  style={{width:'30px'}}
                />
                <input 
                  type="text"
                  id="period"
                  name="period"
                  value={`${selectedPeriod}`}
                  style={{width:'40px'}}
                />
                {/* <div className={classes.customInput}>{`${selectedHour} : ${selectedMinute}  ${selectedPeriod}`} */}
                <img src='/images/clock.png' width="17px" height="17px" alt=''/>
                {/* </div> */}
            </div>
       
        {showPicker && (
         
          <div className={classes.customTimePickerPanel}>
            <div className={classes.timePickerSection}>
              <div className={classes.hourScrollContainer}>
                <div className={classes.hourList}>
                  {[...Array(12).keys()].map((hour) => (
                    <button 
                        className={`${classes.normalBtn} ${dateInSelectedTimes(String(hour + 1).padStart(2, '0'), 'hour') ? classes.focusBtn : ''} `}
                        key={hour + 1} onClick={() => setSelectedHour(String(hour + 1).padStart(2, '0'))}
                    >
                        {String(hour + 1).padStart(2, '0')}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className={classes.timePickerSection}>
              {minutesList.map((minute) => (
                <button className={`${classes.normalBtn} ${dateInSelectedTimes(minute, 'min') ? classes.focusBtn : ''} `}
                    key={minute} onClick={() => handleMinuteSelect(minute)}
                >
                  {minute}
                </button>
              ))}
            </div>
            <div className={classes.timePickerSection}>
              <div className={classes.periodList}>
                {periods.map((period) => (
                  <button className={`${classes.normalBtn} ${dateInSelectedTimes(period, 'period') ? classes.focusBtn : ''} `}
                  key={period} onClick={() => handlePeriodSelect(period)}>
                    {period}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};


